import { SelectionState } from '@bentley/documents-management';

/**
 * Parses Teams tab's subEntityId and constructs {@link SelectionState} object.
 * It also supports legacy scenario where a link to a tab is provided instead of subEntityId.
 *
 * @param {string} subEntityId Teams tab's subEntityId
 * @param {string} linkToUrl Link to a Teams tab (legacy)
 * @returns {SelectionState|undefined} Returns {@link SelectionState} object or {@link undefined}
 */
export function getSelectionState(
  subEntityId?: string,
  linkToUrl?: string
): Partial<SelectionState> | undefined {
  // Newer version - sending selection state as subEntityId
  if (subEntityId?.includes('--') && subEntityId?.split('--').length >= 4) {
    const selection = subEntityId.split('--');
    return {
      currentSetId: selection[0],
      currentProjectId: selection[1],
      selectedItemId: selection[2],
      itemType: selection[3],
      savedSearchId: selection[4],
    } as SelectionState;
  }

  // Older version - sending entire link as subEntityId
  if (linkToUrl) {
    const queryString = linkToUrl.split('?').splice(1).join('');
    const searchParams = new URLSearchParams(queryString);

    const currentProjectId = searchParams.get('project');
    const currentSetId = searchParams.get('set');
    const selectedItemId = searchParams.get('item');
    const itemType = searchParams.get('type');

    if (!currentProjectId && !currentSetId && !selectedItemId && !itemType) {
      return undefined;
    }

    return {
      currentProjectId,
      currentSetId,
      selectedItemId,
      itemType,
    } as SelectionState;
  }
}
